module.exports = __webpack_public_path__ + "static/media/26.78f874b4.png";